const addProjectResponseSchema = ({
  // eslint-disable-next-line camelcase
  title = '', author = '', created_at = '', type = 1, ...data
}) => ({
  project: {
    title,
    description: data.description || '',
    type,
    status: 1,
    deadline_time: data.deadline || '',
    start_time: data.deadline || '',
    created_by: author.id,
    name: title,
    created_at,
    updated_at: created_at,
    image: null,
    members: [],
    author: {},
    customer: null,
    isPending: true,
    ...data,
  },
}
);

const editProjectResponseSchema = data => (
  {
    project: {
      ...data,
      isUpdating: true,
    },
  }
);

const deleteProjectResponseSchema = ({ ...data }) => (
  {
    project: {
      ...data,
      isDeleting: true,
    },
  }
);

export {
  addProjectResponseSchema,
  editProjectResponseSchema,
  deleteProjectResponseSchema,
};
